import React from 'react';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../../styles/rca/RCASearch.module.scss';

const CarListNew = (props) => {
    const { editStep} = props;

    const handleStepChange = () => {editStep('new')}

    return (
        <Col xs={12} md={4}  className={'p-3'}>
            <Card className={`${styles.carItem}`} >
                <Card.Body className="">
                    <Image src="/images/icons/leasing-auto.png" alt="Autovehicul nou" width={100} height={60} />
                    <p className={styles.smallInfo}>Adaugă o altă mașină</p>
                </Card.Body>
                <Card.Footer className="bg-white border-0">
                    <Button className="w-100" onClick={handleStepChange} >
                        Adaugă auto
                        <FontAwesomeIcon icon={faChevronRight} className="ms-2" width="16" height="16"/>
                    </Button>
                </Card.Footer>
            </Card>
        </Col>
    );
}

export default CarListNew;